// extracted by mini-css-extract-plugin
export var notificationHost = "_ls-0";